import React, { useEffect, useState } from "react";
import { Divider, Input, Select, Spin, Tabs } from "antd";
import {
  DetailContainer,
  FormItem,
  FormikForm,
} from "../../../StyledComponents/CreateKeyAccountManager";
import { HeadContainer } from "../../../StyledComponents/Dashboard";
import {
  DetailRow,
  LeftContent,
  MidContent,
  BottomContent,
  RightContent,
  RowValue,
  TableInput,
  TableItem,
  TDItem,
  THeadItem,
  THItem,
  Title,
  TitleDiv,
  TitleRow,
  TopButtonDiv,
  TopContent,
  TRItem,
  TableFilter,
} from "../../../StyledComponents/RateManagement";
import SubmitButton from "../Common/SubmitButton";
import { ErrorMessage } from "formik";
import {
  create_vas_rate,
  move_rate_archive,
} from "../../../store/Admin/RateManagement/RateManagementSlice";
import { useDispatch } from "react-redux";
import {
  airport_list,
  shipment_list,
  shipport_list,
  updatenotificationdata,
} from "../../../store/Admin/Common/CommonSlice";
import axios from "axios";
import SelectSearchAirline from "../Common/SelectSearchAirline";
import SelectSearchPort from "../Common/SelectSearchPort";
import styled from "styled-components";
import * as Yup from "yup";
import { formatDate, handleKeyPress } from "../../../functions/Utils";
import { SpinContainer, TextAreaItem } from "../../../StyledComponents/Queries";
// import AddButton from '../Common/AddButton';
import { TableTab } from "../../../StyledComponents/Common";
// import SelectSearchOceanPort from '../Common/SelectSearchOceanPort';
// import SelectSearchShipline from '../Common/SelectSearchShipline';
// import DateInput from '../Common/DateInput';
// import FormikDateInput from '../Common/FormikDateInput';
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import RadioGroups, { ItemLabel, RadioContainer } from "../Common/RadioGroups";
import AirVasRateForm from "./AirVasRateForm";
import { getallairports } from "../../../store/SearchRates/SearchRatesSlice";
import { getAllOriginDestinationCharges } from "../../../store/ManualQuote/ManualQuoteSlice";
import config from "../../../config";
import { httpinstance } from "../../../axios/api";
// import { IconImg } from '../../../StyledComponents/Header';
//import { REACT_APP_API_BASE_URL_NODE } from '../../utils/secondsToTime';

const { Option } = Select;

const validationSchema = Yup.object().shape({
  

  airport: Yup.array()
    .of(Yup.string().required(""))
    .min(1, "Airport is required"),
  vasRate_charge: Yup.array().of(
    Yup.object().shape({
      type: Yup.string().required("Type is required"),
      chargeHead: Yup.string().required("Charge Head is required"),
      currency: Yup.string().required("Currency is required"),
      exchange_rate: Yup.number().required("Exchange Rate is required"),
      rate: Yup.number().required("Rate is required"),
      unit: Yup.string().required("Unit is required"),
  //     services: Yup.array()
  // .min(1, "At least one service must be selected")
  // .required("Services selection is required"),
    })
  ),
});

function AirVASDetailPage(props) {
  const dispatch = useDispatch();
  const [spinner, setSpinner] = useState(false);
  const [loading, setLoading] = useState(false);
  const [archieve_loading, setArchiveLoading] = useState(false);
  const [type, setType] = useState(props.type);
  // const [tabType, setTabType] = useState("air");
  const [state, setState] = useState({
    airport_list: [],
  });

  const [formData, setFormdata] = useState({
    airport: [],
    chargeList: [],
    currency: [],
  });

  const location = useLocation();
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {
    if (location.pathname === "/rate-management") {
      if (isLoad === false) {
        props.setPageType("table");
      } else {
        setIsLoad(false);
      }
    }
  }, [location]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [airportRes, chargeRes] = await Promise.all([
          dispatch(getallairports()),
          dispatch(getAllOriginDestinationCharges()),
        ]);

        const airport =
          airportRes?.payload?.data?.data?.map((item) => ({
            value: item?._id,
            label: `${item.cityName} - (${item.code})`,
          })) || [];

        const chargeHead =
          chargeRes?.payload?.map((item) => ({
            label: item?.charge_name,
            value: item?._id,
          })) || [];

        const currencyRes = await httpinstance.get("admin/getexchangerates");

        const currencyList =
          currencyRes.status === 200
            ? currencyRes.data?.data?.map((item) => ({
                ...item,
                label: item?.currency,
                value: item?._id,
              }))
            : [];
        setFormdata((prev) => ({
          ...prev,
          airport,
          chargeList: chargeHead,
          currency: currencyList,
        }));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    setState((prevState) => {
      return {
        ...prevState,
        airport_list: props?.airport_list,
      };
    });
  }, [props?.airport_list]);

  // useEffect(()=>{
  //     dispatch(airport_list())
  //     .then(res=>{
  //         // console.log('login res => ',res);
  //         if(res?.payload?.status === 200 ){
  //             const airports = res?.payload?.data?.data
  //             const indianAirports = airports.filter(airport => airport.countryName === 'INDIA' || airport.countryName === 'India');
  //             indianAirports.sort((a, b) => a.name.localeCompare(b.name));

  //             const foreignAirports = airports.filter(airport => airport.countryName !== 'India' || airport.countryName !== 'INDIA');
  //             foreignAirports.sort((a, b) => {
  //             if (a.country === b.country) {
  //                 return a.name.localeCompare(b.name);
  //             }
  //             return a.country.localeCompare(b.country);
  //             });
  //             const sortedAirports = indianAirports.concat(foreignAirports);
  //             let resultPorts = sortedAirports.filter((obj, index, self) =>
  //                 index === self.findIndex((o) => o.code === obj.code)
  //             );
  //             setState((prevState) => {
  //                 return {
  //                     ...prevState,
  //                     airport_list: resultPorts
  //                 }
  //             })
  //             setLoading(false)
  //         }
  //     })
  //     .catch(err=>{
  //         console.error(err);
  //     })
  // },[])

  const handleCancel = (resetForm) => {
    setType("view");
    props.setType("view");
    resetForm();
  };

  const handleEdit = () => {
    setType("edit");
    props.setType("edit");
  };
  const handleSelectChange = (e, name, setFieldValue) => {
    setFieldValue([name], e);
  };

  const handleArchive = () => {
    setArchiveLoading(true);
    let rate_id = props.instance._id;
    const values = {
      rate_id: rate_id,
      customType: "Air",
    };
    dispatch(move_rate_archive(values))
      .then((res) => {
        if (res?.payload?.data?.statusCode === 200) {
          //   console.log(res?.payload?.data?.data);
          dispatch(updatenotificationdata(res?.payload?.data));
          setArchiveLoading(false);
          props.setPageType("table");
          props.setCallList(true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const DateChange = (date, dateString, setFieldValue) => {
    setFieldValue("validity", date);
  };
  const { chargeHead , exchange_rate , rate , unit  , currency}= props.instance;
  const params = {
   id : props.instance?._id,
   airport : props.instance?.airport?._id ? [props.instance?.airport?._id] : [],
   vasRate_charge: [
     {
       type : props.instance?.type,
       chargeHead: chargeHead?._id,
       currency: currency?._id,
       exchange_rate,
       rate,
       unit,
     },
   ],
  }
  const initialValues = {
    airport: [],
    errorMessage : "",
    vasRate_charge: [
      {
        type: "",
        chargeHead: "",
        currency: "",
        exchange_rate: "",
        rate: "",
        unit: "",
        

      },
    ],
    incoterms: [],
    id: "",
    ...params
  };

  const validationCheck = (values) => {
    var i, j;
    let isValid = true;
    const arrayVasRate = [...values.vasRate_charge];
    for (i = 0; i < arrayVasRate.length; i++) {
      for (j = i + 1; j < arrayVasRate.length; j++) {
        if (
          arrayVasRate[i].type === arrayVasRate[j].type &&
          arrayVasRate[i].chargeHead === arrayVasRate[j].chargeHead
        ) {
          values.errorMessage = "Origin and Charge cannot be the same";
          isValid = false
        }
      }
    }
    return isValid;
  };
console.log("type",type);
  if (loading) {
    return (
      <SpinContainer className="user-quote">
        <Spin />
      </SpinContainer>
    );
  } else {
    return (
      <FormikForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          console.log(values);
          if (type === "create"){
            if(!validationCheck(values))
               return;
          }
          delete values.errorMessage;
          setSpinner(true);
          console.log(values);
          const param_data = {
            ...values,
          };
          console.log(param_data);
          if (type === "create"){
             if(!validationCheck(values))
                return;
            try {
              const result = await httpinstance.post(
                "airVas/rate",
                param_data
              );
              // console.log(result);
              if (result?.data?.statusCode === 201) {
                setSpinner(false);
                resetForm();
                props.setCallList(true);
                props.setPageType("table");
                let data = {
                  message: result.data.message,
                  statusCode: 200,
                  success: result.data.status,
                };
                dispatch(updatenotificationdata(data));
              }
            } catch (error) {
              setSpinner(false);
              let data = {
                message: error.response.data.message,
                statusCode: error.response.data.statusCode,
                success: error.response.data.success,
              };
              dispatch(updatenotificationdata(data));
            }
          }
          else {
            const update_data = Object.assign({}, ...values?.vasRate_charge?.map((item) => item));
            try {
              const result = await httpinstance.put(
                `airVas/rate/${values?.id}`,
                update_data
              );
              if (result?.data.statusCode === 201) {
                setSpinner(false);
                resetForm();
                props.setCallList(true);
                props.setPageType("table");
                let data = {
                  message: result.data.message,
                  statusCode: 200,
                  success: result.data.status,
                };
                dispatch(updatenotificationdata(data));
              }
            } catch (error) {
              setSpinner(false)
              let data = {
                message: error.response.data.message,
                statusCode: error.response.data.statusCode,
                success: error.response.data.success,
              };
              dispatch(updatenotificationdata(data));
            }
          }
        }}
      >
        {(formik) => (
          <FormItem>
            <DetailContainer>
              <HeadContainer>
                <TableFilter>
                  <>
                    <TableTab
                      className="first"
                      active={props.tabType === "air"}
                      onClick={() => props.setTabType("air")}
                    >
                      Air
                    </TableTab>
                    {/* {type === 'create'? 
                            <>
                                <Divider type="vertical" />
                                <TableTab active={props.tabType === 'ocean'} onClick={()=> props.setTabType('ocean')}>Ocean</TableTab>
                            </>
                        : null} */}
                  </>
                  <TableFilter className="mb-2">
                    {type === "create" ? (
                      <RadioGroups
                        datas={props.sub_filter}
                        value={props.subTabType}
                        handleClick={
                          Object.keys(props.instance).length === 0
                            ? props.handleRadioClick
                            : null
                        }
                        name="air"
                      />
                    ) : (
                      <ItemLabel className="ml-0">
                        Value added service rate
                      </ItemLabel>
                    )}
                  </TableFilter>
                </TableFilter>
                {/* <Title>Air</Title> */}
                <TopButtonDiv className="mb-3">
                  {/* {type === 'view'?
                                <AddButton title="Move To Archive" icon_type="archive" handleClick={()=> handleArchive()} loading={archieve_loading} />
                            : null} */}
                  {type === "edit" || type === "create" ? (
                    <>
                      {" "}
                      {type === "edit" ? (
                        <SubmitButton
                          type="button"
                          title="Cancel"
                          is_icon={false}
                          handleClick={() => handleCancel(formik.resetForm)}
                        />
                      ) : null}
                      <SubmitButton
                        type="submit"
                        title="save"
                        is_save={true}
                        loading={spinner}
                      />
                    </>
                  ) : (
                    <SubmitButton
                      type="button"
                      title="Edit"
                      icon_type="edit"
                      handleClick={() => handleEdit()}
                    />
                  )}
                </TopButtonDiv>
              </HeadContainer>

              <AirVasRateForm
                type={type}
                formikData={formik}
                formData={formData}
                vasdata={props?.instance}
              />
            </DetailContainer>
          </FormItem>
        )}
      </FormikForm>
    );
  }
}

export default AirVASDetailPage;

const ItemSelect = styled(Select)`
  & .ant-select-selector {
    border-radius: 8px !important;
    padding: ${({ pdg }) => (pdg ? pdg : "unset")};
  }
  & .ant-select-selection-placeholder {
    color: #d9d9d9 !important;
    font-size: 16px;
    font-weight: 400;
  }
  & .ant-select-arrow {
    color: #d9d9d9 !important;
  }
  /* & .ant-select-selection-item {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
    } */
`;
